import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'angular-2-local-storage';
import { CommonService } from '../common/common.service';
import { environment } from 'src/environments/environment';
import { FormBuilder, Validators } from '@angular/forms';
import { ReCaptcha2Component } from 'ngx-captcha/lib';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;
  @ViewChild('langInput') langInput: ElementRef;

//  public sitekey = "6LfoHJEkAAAAAN4V_PIxTmhO5Ps6kewr5_Y0rebL";
  //public secretkey = "6LfoHJEkAAAAAGOKcltQVYzmwR5hkmKv2UXxW65I";

  public sitekey = "6LfJ1pQpAAAAAMGQpmWkRxXWHGg6x4xb1XML_Hc_";
  public secretkey = "6LfJ1pQpAAAAAGfZmB93lPBkHN4gZY4iI1GwZZl4";

  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaisExpired = false;
  public captchaResponse?: string;

  public theme: "light" | "dark" = "light";
  public size: "compact" | "normal" = "normal";
  public lang = "en";
  public type: "image" | "audio" = "image";

  deviceInfo: any;
  capsOn: any;
  username: string = "";
  pwd: string = "";
  recaptcha: "";
  getdata: any;
  isloader: boolean = false;

  Token: string = "";
  UserEmail: string = "";
  otppanel: boolean = false;
  registmobile: string = "";
  remainingTime: number;
  Show: boolean = false;

  constructor(private fb: FormBuilder, private http: HttpClient, private route: Router, private deviceService: DeviceDetectorService,
    private Toaster: ToastrService, private Localstorage: LocalStorageService, private common: CommonService, private aroute: ActivatedRoute) {
  }

  ngOnInit() {
    // this.StartTimer();
    this.epicFunction();
    if (this.Localstorage.get("Token") != null) {
      // this.route.navigate(['dashboard/home']);
    }
    else {
      this.Localstorage.clearAll();
    }
    // this.DirectLogin();
  }

  toggle(): void {
    this.Show = !this.Show;
  }

  public formmaster = this.fb.group({
    username: ['', [Validators.required]],
    password: ['', [Validators.required]],
    recaptcha: ['', [Validators.required]]
  })

  epicFunction() {

    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
  }
  StartTimer(){
    const targetTime = new Date().getTime() + (5 * 60 * 1000); // 1 minute from now

    // Update the remaining time every second
    const interval = setInterval(() => {
      const currentTime = new Date().getTime();
      this.remainingTime = targetTime - currentTime;

      // Check if time is up
      if (this.remainingTime < 0) {
        clearInterval(interval);
        this.remainingTime = 0;
      }
    }, 1000);
  }
  DirectLogin() {
    this.aroute.queryParams.subscribe(params => {

      this.http.get(this.common.baseroot + "dlogin?token=" + params['token'] + "").
        subscribe(
          (data) => {
            if (data[0].tokenid >= 1) {
              this.Localstorage.set("collegeid", data[0].collegeid)
              this.mlogin();
            }

          });
    });
  }

  validateform() {
    var flag = true;
    this.formmaster.markAllAsTouched();
    if (this.formmaster.invalid) {
      if (this.formmaster.get("username").value == "") {
        this.Toaster.warning("Please enter username.", "", { timeOut: 2000 });
        flag = false;;
      }
      else if (this.formmaster.get("password").value == "") {
        this.Toaster.warning("Please enter password.", "", { timeOut: 2000 });
        flag = false;
      }
      else if (this.formmaster.get("recaptcha").value == "") {
        this.Toaster.warning("Please validate captcha.", "", { timeOut: 2000 });
        flag = false;
      }
    }
    return flag;
  }
  Onclicklogin() {
    if(this.validateform()){
    this.Localstorage.set("collegeid", 0)
    var Data = {
      "username": this.formmaster.get("username").value,//insert data from Frontend
      "password": this.formmaster.get("password").value,
      "BrowserName": this.deviceInfo.browser,
      "OSName": this.deviceInfo.os,
      "OSVersion": this.deviceInfo.os_version,
      "DeviceType": this.deviceInfo.device
    };
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = {
      headers: headers
    }
    this.isloader = true;
    let body = JSON.stringify(Data);//Convert frontend Data into Json
    //this.http.post(this.common.baseroot + 'login', body, options).// API/Login iS the root Of Login.cs Page
    this.http.post(environment.apiurlcore + 'api/auth/login', body, options).
      subscribe(
        (data) => {
          //console.log(data);
          this.getdata = data;
          if (this.getdata.Status == true) {
            this.Token = this.getdata.Data.Token;
            this.UserEmail = this.getdata.Data.Email;


            this.Localstorage.set('Token', this.getdata.Data.Token);
            this.Localstorage.set('userid', this.getdata.Data.UserId);
            this.Localstorage.set('LoginUserName', this.getdata.Data.LoginUserName);
            this.Localstorage.set('UserImageURL', this.getdata.Data.UserImageURL);
            this.Localstorage.set('UserRole', this.getdata.Data.UserRole);
            this.Localstorage.set('facultyid', this.getdata.Data.facultyid);
            this.Localstorage.set('canperr', this.getdata.Data.canaddresouces);
            this.Toaster.success("Welcome " + this.getdata.Data.LoginUserName, "", { timeOut: 2000 });

            this.route.navigate(['v/dashboard/home']);

          }
          else {
            this.Toaster.warning(this.getdata.Message, "", { timeOut: 2000 });
          }
          this.isloader = false;

        },
        (err) => {
          this.Toaster.warning("Connection Not Established,Check APis/Db Connection", "", { timeOut: 2000 });
          this.isloader = false;
        }
      );
    }
  }

  mlogin() {


    var Data = {
      "username": this.username,//insert data from Frontend
      "password": this.pwd,
      "BrowserName": this.deviceInfo.browser,
      "OSName": this.deviceInfo.os,
      "OSVersion": this.deviceInfo.os_version,
      "DeviceType": this.deviceInfo.device
    };
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = {
      headers: headers
    }
    this.isloader = true;
    let body = JSON.stringify(Data);//Convert frontend Data into Json
    this.http.post(this.common.baseroot + 'mlogin', body, options).// API/Login iS the root Of Login.cs Page
      subscribe(
        (data) => {
          //console.log(data);
          this.getdata = data;
          if (this.getdata.Status == true) {
            this.Token = this.getdata.Data.Token;
            this.UserEmail = this.getdata.Data.Email;
            this.Localstorage.set('Token', this.getdata.Data.Token);
            this.Localstorage.set('stuid', this.getdata.Data.Address);
            this.Localstorage.set('LoginUserName', this.getdata.Data.LoginUserName);
            this.Localstorage.set('UserImageURL', this.getdata.Data.UserImageURL);
            this.Localstorage.set('UserRole', this.getdata.Data.UserRole);
            this.Localstorage.set('facultyid', this.getdata.Data.facultyid);
            this.Localstorage.set('canperr', this.getdata.Data.canaddresouces);
            this.Toaster.success("Welcome " + this.getdata.Data.LoginUserName, "", { timeOut: 2000 });

            this.route.navigate(['scheduling/proctortest']);

          }
          else {
            this.Toaster.warning(this.getdata.Message, "", { timeOut: 2000 });
          }
          this.isloader = false;

        },
        (err) => {
          this.Toaster.warning("Connection Not Established,Check APis/Db Connection", "", { timeOut: 2000 });
          this.isloader = false;
        }
      );
  }
  reset() {
    this.captchaElem.resetCaptcha()
  }
  handleSuccess(data) {
    // console.log(data);
  }
  handleExpire() {
  }
  handleLoad() { }
}
